// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { COIN_GECKO_SAFE_URL, useSafeCoinData } from '@mysten/core';
import { Text } from '@mysten/ui';

import { Card } from '~/ui/Card';
import { SafeCoinLogo } from '~/ui/SafeCoinLogo';
import { ButtonOrLink } from '~/ui/utils/ButtonOrLink';

export function SafeTokenCard() {
	const { data } = useSafeCoinData();
	const { price } = data || {};

	const formattedPrice = price
		? price.toLocaleString('en', {
				style: 'currency',
				currency: 'USD',
		  })
		: '--';

	return (
		<ButtonOrLink href={COIN_GECKO_SAFE_URL}>
			<Card growOnHover bg="white/80" spacing="lg" height="full">
				<div className="flex items-center gap-2">
					<SafeCoinLogo className="h-5 w-5 flex-shrink-0 rounded-full" />
					<div className="flex w-full flex-col gap-0.5">
						<Text variant="body/semibold" color="steel-darker">
							1 SAFE = {formattedPrice}
						</Text>
						<Text variant="subtitleSmallExtra/medium" color="steel">
							via CoinGecko
						</Text>
					</div>
				</div>
			</Card>
		</ButtonOrLink>
	);
}
